module.exports = __webpack_public_path__ + "static/media/importSchoolCooperationPerson.36db160a.xlsx";